// src/features/auth/AuthLoadingGate.tsx
"use client";
import { useAnonAuth } from "./AnonAuthProvider";

interface AuthLoadingGateProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/** Delays render until Authsession is loaded */
export function AuthLoadingGate({ children, fallback }: AuthLoadingGateProps) {
  const { loading, error } = useAnonAuth();

  if (loading) {
    return (
      fallback || (
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-muted-foreground">Setting up your session...</p>
          </div>
        </div>
      )
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-red-600 mb-4">Authentication Error: {error}</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/90"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
